import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Container, Columns, Column } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import ProfileInfo from './ProfileInfo'
import ProfileUpdatePassword from './ProfileUpdatePassword'
import { getCurrentUserStores } from '../../store/actions/store-info-actions'
import { updateProfile } from '../../store/actions/users-actions'
import Banner from '../../components/CommonUI/Banner/Banner'
import { getText } from '../../internal/TextLabels'

class Profile extends React.Component {
  componentDidMount() {
    this.props.getCurrentUserStores()
  }

  render() {
    const { auth, stores } = this.props
    return (
      <Container grid960>
        <Columns>
          <Column col3 colMd2 colSm0 />
          <Column col6 colMd8 colSm12>
            {auth.me?.temporaryEmail && (
              <Banner
                faIcon={faExclamationTriangle}
                type="warning"
                text={getText('user.temporaryEmail', auth.me.temporaryEmail)}
              />
            )}
            {stores.length > 0 ? (
              <ProfileInfo
                me={auth.me}
                auth={auth}
                stores={stores}
                onSave={updatedInfo => this.props.updateProfile(updatedInfo)}
              />
            ) : (
              <div className={midas.loading} />
            )}
          </Column>
        </Columns>
        <Columns>
          <Column col3 colMd2 colSm0 />
          <Column col6 colMd8 colSm12>
            <ProfileUpdatePassword />
          </Column>
        </Columns>
      </Container>
    )
  }
}

Profile.propTypes = {
  auth: PropTypes.object.isRequired,
  stores: PropTypes.array,
  getCurrentUserStores: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
}

Profile.defaultProps = {
  stores: [],
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    stores: state.storeInfo.stores,
  }
}

const mapDispatchToProps = dispatch => ({
  getCurrentUserStores: () => {
    dispatch(getCurrentUserStores())
  },
  updateProfile: user => {
    dispatch(updateProfile(user))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
